import React from "react";
const TextAreaForm = ({style, placeholder,intype,event,name,value}) => {
    return (
        <textarea class={style} defaultValue={value} type={intype} {...event(name)} placeholder={placeholder}></textarea>
    )
}
export default TextAreaForm;